import { render } from "./RiProdoffering267.vue?vue&type=template&id=079c0e8e"
import script from "./RiProdoffering267.vue?vue&type=script&lang=js"
export * from "./RiProdoffering267.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdoffering267.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "079c0e8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('079c0e8e', __exports__)) {
    api.reload('079c0e8e', __exports__)
  }
  
  module.hot.accept("./RiProdoffering267.vue?vue&type=template&id=079c0e8e", () => {
    api.rerender('079c0e8e', render)
  })

}


export default __exports__